import React from 'react';
import { X } from 'lucide-react';
import { problemVsSolutionContent } from './landingContent';

export const ProblemVsSolutionSection: React.FC = () => {
  const { heading, subheading, oldWay, hustliWay } = problemVsSolutionContent;

  return (
    <section className="px-4 py-16 md:py-20 bg-cream border-t border-stone-200/80">
      <div className="max-w-5xl mx-auto">
        {/* Small brand separator so pricing -> problem/solution doesn't feel run-on */}
        <div className="w-full flex justify-center mb-6 md:mb-8">
          <div className="h-2 w-32 rounded-full bg-gradient-to-r from-secondary/70 via-primary/70 to-secondary/30" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-3 text-dark">
          {heading}
        </h2>
        <p className="text-center text-stone text-lg mb-10 md:mb-12 max-w-2xl mx-auto leading-relaxed">
          {subheading}
        </p>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          <div className="rounded-2xl border-2 border-[#DC2626]/30 bg-[#FEE2E2] p-6 md:p-8 shadow-card">
            <p className="text-sm font-semibold uppercase tracking-wide text-[#991B1B] mb-4">
              {oldWay.label}
            </p>
            <ul className="space-y-3">
              {oldWay.items.map((item) => (
                <li key={item} className="flex gap-3 text-dark text-sm md:text-base leading-snug">
                  <span
                    className="flex-shrink-0 mt-0.5 w-5 h-5 rounded-full bg-red-100 flex items-center justify-center"
                    aria-hidden
                  >
                    <X className="w-3 h-3 text-[#991B1B]" strokeWidth={2.5} />
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-2xl border-2 border-primary/35 bg-[#D1FAE5] p-6 md:p-8 shadow-card">
            <p className="text-sm font-semibold uppercase tracking-wide text-primary mb-4">
              {hustliWay.label}
            </p>
            <ul className="space-y-3">
              {hustliWay.items.map((item) => (
                <li key={item} className="flex gap-3 text-dark text-sm md:text-base leading-snug">
                  <span
                    className="flex-shrink-0 mt-0.5 w-5 h-5 rounded-full bg-primary text-white flex items-center justify-center font-bold text-xs"
                    aria-hidden
                  >
                    ✓
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
